/**
 * Created by mateimisarca on 2019-06-07
 */

import Footer from './footer';
export default Footer;
